
class FormSubmit {
  constructor(store, formData) {
    this.store = store;
    this.form = formData;
    
    this.selectedAcc = [];
    this.selectedAccPrice = [];
    this.accessoriesWithPricing = [];
    
    this.selections = this.store.state.optionSelections;
    this.modelOptions = this.store.getters.currPool.options;
  }
  submit() {
    return new Promise((resolve, reject) => {
      // json object to be sent in request body to api endpoint
      const body = this.prepareDataForApi();
      console.log('data to send: ', body);
      // make sure we don't allow sending request to API if failed to build data object
      if (!body) {
        console.log('body value not as expected', body);
        reject('no object to send');
        return;
      }

      // display object in UI, if form-debug enabled
      if (window.formDebug) {
        document.querySelector('#form-debug-output').innerText = JSON.stringify(body, null, 2);
      } 

      var xhr = new XMLHttpRequest();
      // get the API endpoint address corresponding to the specific website
      xhr.open('POST', this.store.getters.getFormEndpoint);
      // headers for the US site API
      if (this.store.getters.getFormApiFormat === 'us-site') {
        xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
        xhr.setRequestHeader('Access-Control-Allow-Methods', 'GET, POST, OPTIONS');
        xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
        xhr.setRequestHeader('Access-Control-Allow-Headers', 'Content-Type, Content-Range, Content-Disposition, Content-Description');
      }
      // headers for Salesforce API
      if (this.store.getters.getFormApiFormat === 'sf-public-site-guest') {
        xhr.setRequestHeader('Content-Type', 'application/json');
      }

      // handler for when the request completes. validate response
      xhr.addEventListener('load', () => {
        console.log('xhr.response:', xhr.response);
        // if response code is good
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            // expecting JSON object in string of response body. Parse it.
            let resp = JSON.parse(xhr.response);
            // endpoint expected to include status property in response object
            if (resp.status) {
              // The US API response object's "status" property value is expected to be lowercase.
              // The (UK) Salesforce API response object's "status" property value is expected to be leading cap.
              // So we do toLowerCase().
              if (resp.status.toLowerCase() === 'success') {
                resolve();
              } else {
                // both US and Salesforce APIs may include 'message' property in response
                if (resp.message) {
                  reject({errorMessage: 'API error. Status: ' + resp.status + '. Message: ' + resp.message});
                } else {
                  reject({errorMessage: 'API error'});
                }
              }
            } else {
              reject({errorMessage: 'API response missing status property.'});
            }
          } catch (e) {
            reject({errorMessage: 'Failed to parse response JSON.'});
          }
        } else {
          reject({errorMessage: 'Bad response status from API: ' + xhr.status});
        }
      });

      // State change handler
      xhr.onreadystatechange = function (event) {
        console.info('Form submit state change:', event)
      };

      // Error handler
      xhr.addEventListener('error', function (event) {
        console.log('Form submit error. Event:', event);
        reject(event);
      });

      xhr.send(JSON.stringify(body));
    });
  }
  prepareDataForApi() {
    // first prepare some values 

    // accessory data
    for (let id of this.store.state.selectedAccessories) {
        const price = this.store.getters.summaryAccessoryPricing(id);
        // Format 1
        this.selectedAcc.push(id);
        this.selectedAccPrice.push(price);
        // Format 2
        this.accessoriesWithPricing.push({ accessory: id, price });
    }

    // size data
    this.selectedLengthObj = this.modelOptions.len.choices.find(c => c.id === this.selections.len.value);
    this.selectedWidthObj = this.modelOptions.width.choices.find(c => c.id === this.selections.width.value);
    this.selectedDepthObj = this.modelOptions.depth.choices.find(c => c.id === this.selections.depth.value);

    // get the "translated" size measurements to send
    this.tLength = parseFloat(this.selectedLengthObj.measurement);
    this.tWidth = parseFloat(this.selectedWidthObj.measurement);
    this.tDepth = parseFloat(this.selectedDepthObj.measurement);
    this.tLength = isNaN(this.tLength) ? 0 : this.tLength;
    this.tWidth = isNaN(this.tWidth) ? 0 : this.tWidth;
    this.tDepth = isNaN(this.tDepth) ? 0 : this.tDepth;

    // now put data in object to send to API. 
    // form sends to different APIs depending on website. use data format specified in site configuration 
    let body = null; 
    switch (this.store.getters.getFormApiFormat) {
      case 'us-site':
        // request body JSON object format for US site's endpoint
        body = this.getBodyUs()
        break;
      case 'sf-public-site-guest':
        // request body JSON object format for sites using Salesforce endpoint
        body = this.getBodySf()
        break;
    }

    // object to send in body of request to API endpoint 
    return body
  }
  getBodyUs() {
    // for readability
    let { state, getters } = this.store;
    const body = {}

    // how the US site API gets the data
    body.category = getters.categoryTagOfSelectedModel
    body.model = getters.currPool.tag
    body.includedAccessories = getters.includedAccessories
    body.selections = {
      length: this.tLength,
      width: this.tWidth,
      depth: this.tDepth,
      units: {
        length: this.modelOptions.len.unit,
        width: this.modelOptions.width.unit,
        depth: this.modelOptions.depth.unit,
      },
      location: this.selections.location.value.toLowerCase(),
      install: this.selections.install.value.toLowerCase(),
      skirting: this.selections.skirting.value,
      // These two arrays go together
      accessories: this.selectedAcc, // Accessory ID array
      // AccessoriesPrice is a new addition to the API
      // Did not want to alter old API (change the accessories array)
      accessoriesPrice: this.selectedAccPrice, // Accessory price array
      // Same information above, but in a new format that is easier to
      // work with, but requires server-side refactoring to use
      accessoriesWithPricing: this.accessoriesWithPricing,
    }
    // MSRP Total here refers to pool total
    body.msrpPricing = {
      lengthCost: (getters.showPricing ? getters.lenPrice : 0),
      widthCost: (getters.showPricing ? getters.widthPrice : 0),
      depthCost: (getters.showPricing ? getters.depthPrice : 0),
      linerCost: (getters.showPricing ? getters.linerPrice : 0),
      msrpTotal: (getters.showPricing ? getters.poolPrice : 0),
    }
    body.contact = {
      firstName: this.form.firstName.trim(),
      lastName: this.form.lastName.trim(),
      email: this.form.email.trim(),
      address: this.form.address.trim(),
      zip: this.form.zip.trim(),
      country: this.form.country.trim(),
      phone: this.form.phone.trim(),
    }
    body.likelyUse = this.form.likelyUse.trim()
    body.emailOptIn = this.form.emailOptIn
    // US site destination endpoint seems to validate for this field to be present have a value like this.
    // Previously we sent a screenshot with window.pc.Application.getApplication().graphicsDevice.canvas.toDataURL();
    // The screenshot is no longer needed by client, so including a placeholder 5x5 pixel image, until validation changed. 
    body.preview = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAADElEQVQImWNgoBMAAABpAAFEI8ARAAAAAElFTkSuQmCC'
    // Data that only exists for specific pool types
    if (getters.categoryTagOfSelectedModel === 'custom') {
      body.selections.coping = state.optionSelections.coping.value;
      body.selections.liner = state.optionSelections.liner.value;
    } else if (getters.categoryTagOfSelectedModel === 'spa') {
      body.selections.shell = state.optionSelections.shell.value;
    }

    return body
  }
  getBodySf() {
    const body = {}

    // how the UK salesforce API gets the data
    body.RecordType = 'Customer_Opportunity'
    body.Customer_First_Name__c = this.form.firstName.trim()
    body.Customer_Last_Name__c = this.form.lastName.trim()
    body.Customer_Email__c = this.form.email.trim()
    body.Customer_Phone__c = this.form.phone.trim()
    body.Customer_Address_Street__c = this.form.address.trim()
    body.Customer_Address_Postal_Code__c = this.form.zip.trim()
    body.Customer_Address_Country__c = this.form.country.trim()
    body.Opt_Out_of_Email__c = !this.form.emailOptIn
    body.Watkins_Brand__c = 'EP Fit Sys'
    body.Brand__c = 'Endless Pools'
    body.EP_Product_Interest__c = this.store.getters.categoryTagOfSelectedModel === 'custom' ? 'Original Endless Pools' : 'Fitness System'
    body.Initial_Lead_Source__c = 'Website'
    body.Description = this.getOneFieldDumpSf()
    
    return body
  }
  // multiple pieces of data get dumped in one big value that gets assigned in one field in Salesforce
  getOneFieldDumpSf() {
    let str = '';
    // const separator = '/n';
    const separator = '  ';

    str += 'User selections from 3D web customizer: ' + separator;
    str += 'model: ' + this.store.getters.currPool.tag + separator;
    str += 'location: ' + this.selections.location.value.toLowerCase() + separator;
    str += 'install: ' + this.selections.install.value.toLowerCase() + separator;
    str += 'skirting: ' + this.selections.skirting.value + separator;
    str += 'length: ' + this.tLength + this.modelOptions.len.unit + separator;
    str += 'width: ' + this.tWidth + this.modelOptions.width.unit + separator;
    str += 'depth: ' + this.tDepth + this.modelOptions.depth.unit + separator;
    
    // Data that only exists for specific pool types
    if (this.store.getters.categoryTagOfSelectedModel === 'custom') {
      str += 'coping: ' + this.store.state.optionSelections.coping.value + separator;
      str += 'liner: ' + this.store.state.optionSelections.liner.value + separator;
    } else if (this.store.getters.categoryTagOfSelectedModel === 'spa') {
      str += 'shell: ' + this.store.state.optionSelections.shell.value + separator;
    }

    str += 'purpose: ' + this.form.likelyUse.trim() + separator;
    str += 'accessories: ' + this.selectedAcc.join(', ') + separator;

    return str
  }
};

export default FormSubmit;
